module.exports = __webpack_public_path__ + "img/type.f7056850.svg";